<template>
	<div
		id="operationType-management"
		:class="[!isWeb ? 'mobile-operationType-management' : '', !isWeb && isSafari ? 'safari' : '']"
	>
		<div class="operationType-management__body">
			<TableFilter :isWeb="isWeb" @searchFromInput="searchFromInput" />
			<OperationTable
				:isWeb="isWeb"
				:currentPage="page"
				@changePage="changePage"
				@refreshOperationType="refreshOperationType"
				@orderByHeader="orderByHeader"
			/>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import { GET_ALL_OPERATIONS } from '@/store/modules/operationTypeManagement/actions';
import TableFilter from '@/components/modules/Operation/OperationTypeManagement/TableFilter/TableFilter.vue';
import OperationTable from '@/components/modules/Operation/OperationTypeManagement/Table/Table.vue';

export default {
	name: 'OperationTypeManagement',
	components: { TableFilter, OperationTable },
	data: () => ({
		windowWidth: window.innerWidth,
		page: 1,
		searchParams: null,
		headerSelected: null,
		orderSelected: null,
	}),
	created() {
		this.refreshOperationType();
	},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize);
		});
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	},
	methods: {
		...mapActions('operationTypeManagement', {
			getOperations: GET_ALL_OPERATIONS,
		}),
		onResize() {
			this.windowWidth = window.innerWidth;
		},
		changePage(params) {
			this.page = params.params;
			this.refreshOperationType();
		},
		searchFromInput(params) {
			this.searchParams = params;
			this.page = 1;
			this.refreshOperationType();
		},
		orderByHeader(param) {
			this.headerSelected = param;

			if (!this.orderSelected || this.orderSelected == 'ASC') {
				this.orderSelected = 'DESC';
			} else {
				this.orderSelected = 'ASC';
			}

			this.refreshOperationType();
		},
		refreshOperationType() {
			let params = `?limit=20&page=${this.page}`;
			if (this.searchParams) params += `&search=${this.searchParams}`;
			if (this.headerSelected)
				params += `&orderColumn=${this.headerSelected}&orderDirection=${this.orderSelected}`;

			this.getOperations({ vm: this, params: params });
		},
	},
	computed: {
		isWeb() {
			return this.windowWidth > 992;
		},
		isSafari() {
			return navigator.vendor == 'Apple Computer, Inc.';
		},
	},
};
</script>

<style lang="scss">
@import 'OperationTypeManagement.scss';
</style>
